import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Switch from "@coworker/apprestructured/src/task-management/components/Switch/Switch";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import {
  FragmentIconName,
  FRAGMENT_ICON_NAMES,
  useFragmentIcon,
} from "@coworker/apprestructured/src/task-management/fragments/useFragmentIcon";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";

function SwitchDemo() {
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [label, setLabel] = useState("Label");
  const [iconName, setIconName] = useState<FragmentIconName>("notice-circle");
  const icon = useFragmentIcon(iconName);

  return (
    <Demo>
      <Name>Switch</Name>
      <Highlight>
        <FixaListView id="switchdemo" size="small">
          <Switch
            icon={icon}
            label={label}
            disabled={disabled}
            checked={checked}
            onCheckedChange={setChecked}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="switchdemo-disabled"
          id="switchdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaInputField
          label="label"
          type="text"
          id="switchdemo-label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        <FixaSelect
          id="switchdemo-iconName"
          value={iconName}
          onChange={(e) => setIconName(e.target.value as FragmentIconName)}
          label="icon"
          required
        >
          {FRAGMENT_ICON_NAMES.map((name) => {
            return <FixaOption key={name} name={name} value={name} />;
          })}
        </FixaSelect>
      </Actions>
    </Demo>
  );
}

export default memo(SwitchDemo);
